<script>
  import { mapGetters, mapActions } from 'vuex';
  import { useAlert } from 'dashboard/composables';

  export default{
    props: {
      scheduleId: {
        type: String,
        default: null,
      },
      resetCreateWorkingHours: {
        type: Function,
        default: () => {},
      },
      editWorkingHoursId: {
        type: Number,
        default: null,
      },
      isEditingWorkingHours:{
        type: Boolean,
        default: false,
      },
      refreshPage:{
        type: Function,
        default: () => {},
      }
    },
    data(){
      return{
        scheduleName: '',
        workingHours: [{
          "day_of_week": 0,
          "end_time": "17:00:00",
          "start_time": "09:00:00"
        }],
        days: ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'],
      }
    },
    computed:{
      ...mapGetters('appointments', ['selectedSchedule']),
    },
    methods: {
      ...mapActions('appointments', ['createWorkingHours', 'fetchWorkingHours', 'editWorkingHours']),
      
      async handleCreateWorkingHours(){
        try{
          await Promise.all(
            this.workingHours.map(wh => this.createWorkingHours({ scheduleId: this.scheduleId, payload: wh }))
          );
        } catch(err){
          console.error(err);
          useAlert(err);
        } finally{
          this.refreshPage();
          this.resetCreateWorkingHours();
        }
      },

      async handleEditWorkingHours(){
        try{
          await this.editWorkingHours({ scheduleId: this.scheduleId, workingHoursId: this.editWorkingHoursId, payload: this.workingHours[0] })
        } catch(err){
          console.error(err);
          useAlert(err);
        } finally{
          this.refreshPage();
          this.resetCreateWorkingHours();
        }
      },

      addWorkingHour() {
        this.workingHours.push({ day: null, start_time: '', end_time: '' });
      },

      removeWorkingHour(index) {
        this.workingHours.splice(index, 1);
      },

      isDaySelected(day, currentIndex) {
        return this.workingHours.some((wh, i) => wh.day_of_week === day && i !== currentIndex);
      },

    },
    async mounted(){
      try{
        if(this.isEditingWorkingHours){
          const response = await this.fetchWorkingHours(this.scheduleId);
          const response2 = response.find((wh) => wh.id === this.editWorkingHoursId)
          this.workingHours = [{
            day_of_week: response2.day_of_week,
            end_time: response2.end_time,
            start_time: response2.start_time
          }];
        }
      }catch(err){
        console.error(err);
        useAlert(err);
      }
    }
  }
</script>

<template>
  <div class="p-6 border-2 rounded-lg bg-white dark:bg-slate-800 shadow-lg max-w-md w-full mx-auto">
    <!-- Input Field -->
    <div v-for="(workingHour, index) in workingHours" :key="index" class="mb-2">
        <select v-model="workingHour.day_of_week">
          <option :value="null" disabled>Select Day</option>
          <option v-for="(day, i) in days" :key="i" :value="i" :disabled="isDaySelected(i, index)">{{ day }}</option>
        </select>
        <input type="time" v-model="workingHour.start_time">
        <input type="time" v-model="workingHour.end_time">
        <woot-button v-if="workingHours.length > 1" @click="removeWorkingHour(index)">Remove</woot-button>
    </div>
    <woot-button v-if="!isEditingWorkingHours" @click="addWorkingHour">+ Add Day</woot-button>

    <!-- Action Button -->
    <button 
      @click="isEditingWorkingHours ? handleEditWorkingHours() : handleCreateWorkingHours()"
      class="w-full py-2 mt-2 text-white font-medium rounded-md transition 
        bg-woot-600 hover:bg-woot-700 focus:ring-2 focus:ring-woot-400 focus:outline-none"
    >
      {{ isEditingWorkingHours ? "Edit" : "Create" }} Working Hours
    </button>
  </div>
</template>